import React from 'react'

import PropTypes from 'prop-types'

import css from './Waves.css'

export const Waves = ({ fillColor }) => (
  <div className={css.waves}>
    <svg className={css.wave} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1240 20">
      <path
        style={{ fill: fillColor }}
        d="M1037.74,0h-13.15a14.42,14.42,0,0,0,6.9,1.57A17.19,17.19,0,0,0,1037.74,0Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M948.12,15.14c13.18-1.68,24.37-7.53,34.25-12.68C984,1.61,985.58.78,987.12,0H971.8c-7.46,3.67-15.64,7.05-24.57,8.19C935.38,9.7,922.4,5,909.69,0H890.17c4.36,1.49,8.87,3.29,13.49,5.14C918.28,11,933.39,17,948.12,15.14Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M337.42,7.8c23.44-2.19,36.48-2.35,56.5,2.32C406.18,13,417.34,10,428.14,7.2,437,4.87,445.36,2.68,454.4,3.36c8.79.66,15.52,3.05,22.65,5.57,9.37,3.32,20,7.07,36.54,7.2,2.16.08,4.25.11,6.3.11,20.92,0,35.91-3.64,49.27-6.88,10.32-2.51,19.22-4.68,28.56-4.4a143.29,143.29,0,0,1,23.9,2.55,61.26,61.26,0,0,0,15.84,1.35c5.94-.34,12.62-2.15,19.09-3.91,7-1.89,14.22-3.86,18.49-3.21s8.66,3,13.4,5.44,9.47,4.94,14.59,6.13l.17,0c10.4,1.88,23.7-.94,36.55-3.67,7.63-1.62,14.83-3.15,20.85-3.57a173.85,173.85,0,0,1,20.64.24c9.53.48,18.55.93,25.62-.86,20.78,2.67,35.2-1.71,46.81-5.24l.8-.24H752.7c-4.54.72-9.38,1.75-14.41,2.82-12.15,2.58-24.71,5.25-33.76,3.65-4.22-1-8.61-3.29-12.85-5.5l-1.86-1h-42a62,62,0,0,1-10.78,1.87c-5.48.32-9.14-.34-14.2-1.25L619.37,0H578.54c-3.56.74-7.2,1.62-11,2.55C553.28,6,537.15,9.92,513.73,9.13c-15.47-.12-25.06-3.52-34.34-6.8-2.27-.81-4.51-1.6-6.79-2.33H428l-1.62.42c-10.44,2.74-20.3,5.33-30.86,2.88a151.08,151.08,0,0,0-19-3.3H346.48c-3.06.23-6.27.51-9.71.83C323.62,2.06,316.9,2,309.87,0H291C308.51,7.9,313.89,10,337.42,7.8Z"
      />
      <path style={{ fill: fillColor }} d="M1240.12V0h-.42Z" />
      <path
        style={{ fill: fillColor }}
        d="M33.27,11.47c19.51-4.28,27.95-5,46.18-1.7,30.11,6,45.34,1.67,66.43-4.3,6.17-1.75,12.85-3.64,20.57-5.47h-27C121,5.17,107.18,8.14,80.76,2.89,61.42-.63,52,.19,31.77,4.62,17.42,7.77,7.06,6.87,0,5v7.21C7.87,14,18.81,14.63,33.27,11.47Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M1240,6.7c-29.39-7.93-55.68-5.28-73.62-3.47-5.16.52-9.61,1-12.89,1h-.13c-3.82,0-10.4-1.76-18.18-4.23H1115l5.57,1.89c14.9,5.05,27.77,9.45,34.92,9.34,3.59,0,8.19-.5,13.51-1,17.78-1.79,44-4.43,72.92,3.78Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M947.53,1.12C949.64.85,951.7.46,953.72,0H929.35A53.53,53.53,0,0,0,947.53,1.12Z"
      />
      <path style={{ fill: fillColor }} d="M30.45,0h-29C7.54,2.05,15.72,3.23,28.18.5Z" />
      <path
        style={{ fill: fillColor }}
        d="M513,2.12c2.16.07,4.25.1,6.3.1A167.13,167.13,0,0,0,546.77,0H493.36A94.84,94.84,0,0,0,513,2.12Z"
      />
    </svg>
    <svg className={css.wave} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1240 20">
      <path
        style={{ fill: fillColor }}
        d="M719.48,20.46c-7.25-4-14.73-8.17-24.92-10.25-11.76-2.4-22.76-.48-33.39,1.38-7.71,1.35-15.69,2.74-23.8,2.44a61.15,61.15,0,0,1-14.5-2.73C616.68,9.56,610.28,7.76,601,9.15c-8.49,1.19-14.61,4.1-21.09,7.19A117.93,117.93,0,0,1,566.58,22h17.75c5.66-2.69,10.79-5,17.68-5.91,7.82-1.18,13,.27,19,1.95a67.23,67.23,0,0,0,16.09,3c8.9.34,17.24-1.12,25.31-2.53,10.45-1.83,20.32-3.55,30.78-1.42A60,60,0,0,1,707.38,22h14.89Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M821.8,18c-10.53-1.17-21.43-2.38-31.85-3.31-11.14-1-19.07,3.2-26,7.35h17.59a28.55,28.55,0,0,1,7.78-.38l4,.38h70C850.66,21.16,836.49,19.59,821.8,18Z"
      />
      <path style={{ fill: fillColor }} d="M1242.43,21.57l-2.38.43h2.38Z" />
      <path
        style={{ fill: fillColor }}
        d="M1099.47,12c-4.55-1.09-8.85-2.11-13.06-2.82-8.77-1.5-16.62.57-26.57,3.19a188.71,188.71,0,0,1-32.16,6.18c-14.88,1.51-28.37-.42-44-2.65-11.53-1.65-24.61-3.52-39.64-4-20-.69-29.63,2.85-38.13,6a69.78,69.78,0,0,1-15,4.19h24.34c6.69-2.06,14.93-3.62,28.57-3.16A309.84,309.84,0,0,1,976.93,22h73.15c4.27-1,8.08-2,11.55-2.88,9.48-2.49,16.33-4.3,23.61-3.06,4,.67,8,1.63,12.61,2.73,4.33,1,9.06,2.16,14.5,3.21h97.88c9.86-1.26,20.55-2.87,32.2-4.89V10C1155.18,25.26,1121.77,17.3,1099.47,12Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M.57,21.85a3.51,3.51,0,0,0,2.35-.42c8.23-4.85,18.25-2.62,29.77.57h74.37c2.32-.69,4.53-1.38,6.59-2,7.9-2.47,14.13-4.41,19-4.14a42.85,42.85,0,0,1,14.87,3.66,72,72,0,0,0,7.06,2.5h34.5c5.78-.77,11.94-1.7,18.23-2.65,17.76-2.7,36.12-5.49,46.58-4.41,11,1.11,22.06,3.4,33.76,5.82l6,1.24h84.86c2.26-1,4.31-2.06,6.22-3,5.37-2.7,9.25-4.64,13.16-4.2h.1c5.48.45,10.45,2,15.7,3.64A126.36,126.36,0,0,0,426.9,22h29.77c1-.17,2-.34,3-.55,4.51-.9,9.63-.51,15.14.55h26.85c-2.43-.69-4.85-1.4-7.25-2.1-13.05-3.84-25.37-7.46-36.11-5.32-20.39,4.08-31.65.57-42.54-2.83-5.62-1.75-10.93-3.41-17.16-3.93-6-.65-11.09,1.93-17,4.91s-13.33,6.69-24.2,8.57c-25.48,1.49-47.26-3-68.32-7.39C277.2,11.44,266,9.12,254.61,8s-30.15,1.69-48.34,4.45c-16.25,2.47-33.06,5-42.15,4.2a44,44,0,0,1-14-3.64,49.71,49.71,0,0,0-17-4.13c-6.16-.37-12.93,1.76-21.51,4.44C99.15,17.18,83.69,22,63.29,21.2c-8.76-.34-17.3-2.74-25.56-5.06C24.42,12.39,11.81,8.85.57,14.73Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M398.63,19.37c-4.34-.47-8.25.77-12.34,2.63h25.25A63.52,63.52,0,0,0,398.63,19.37Z"
      />
      <path
        style={{ fill: fillColor }}
        d="M254.61,20.18c-7.87-.81-19.35.24-31.72,1.82h45.18C263.57,21.27,259.1,20.64,254.61,20.18Z"
      />
    </svg>
  </div>
)

Waves.propTypes = {
  fillColor: PropTypes.string.isRequired,
}
